import TemplateView from '../TemplateView'

export default class DateRangeSelector extends TemplateView {
    constructor({
        extraClass = '',
        selectorId,
        rangeMaxDays,
        rangeTooLongMessageKey,
        menuStates,
        onSelectionChanged = () => {},
    }) {
        super()

        this.params = {
            extraClass,
            selectorId,
            rangeMaxDays,
            rangeTooLongMessageKey,
            menuStates,
        }

        this.callbacks = {
            onSelectionChanged,
        }

        this.state = {
            selection: null,
            selectionValid: false,
        }

        this.onStatePropertyDeeplyChanged('selection', (currentSelection, prevSelection) => {
            if (currentSelection && !prevSelection) {
                this._renderSelector(currentSelection)
            }
        })

        this.onStatePropertyChanged('selectionValid', selectionValid => this.getEl().toggleClass('incorrectDateRange', !selectionValid))
    }

    templateHtml() {
        return `<div id='<%=dateSelectorId%>' class='<%=extraClass%> dateRangeSelector'/>`
    }

    templateModel() {
        return {
            extraClass: this.params.extraClass,
            dateSelectorId: this.params.selectorId,
        }
    }

    _renderSelector(selection) {
        this.getEl().empty()

        this.dateSelectorController = new window.DateRangeSelectorController().init({
            dateRangeSelection: selection,
            dateRangeParsed: true,
            rangeMaxDays: this.params.rangeMaxDays,
            rangeTooLongMessageKey: this.params.rangeTooLongMessageKey,
            renderTo: this.params.selectorId,
            menuStates: this.params.menuStates,
            callOnChangeCallbackIfInvalid: true,
        })

        this.dateSelectorController.setOnChangeCallback((() =>
            this.callbacks.onSelectionChanged({
                dateRangeSelection: this.dateSelectorController.getSelectedRange(),
                dateRangeValid: !this.dateSelectorController.hasErrors(),
            })))
    }
}



// WEBPACK FOOTER //
// ./web/js/components/DateRangeSelector.js